import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfigService } from '../config/config.service';
import { UserService } from '../shared/services/user.service';
import { SessionService } from '../shared/services/session.service';
import { Message } from 'primeng/primeng';
import { CommonDataService } from '../shared/services/common-data.service';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.css']
})
export class ThankyouComponent implements OnInit {
  hideUI: boolean = false;
  recoverPassData: FormGroup;
  msg: Message[];
  submitted: boolean = false;
  market: string;
  constructor(private commonDataService: CommonDataService,
              private userService: UserService,
              private sessionService: SessionService,
              private router: Router,
              private configService: ConfigService) {
      this.recoverPassData = new FormGroup({
          'username': new FormControl('', Validators.required)
      });
  }

  ngOnInit() {
      /*'ve' === this.configService.market ? this.market = 'VENTURA_MARKET' :
          'sb' === this.configService.market ? this.market = 'SANTA_BARBARA_MARKET' : this.market = this.configService.market;*/

      // Settled on sending a template for SB market for "Member Forgot Password", considering that the WEB UI is divided to VE and SB
      // at the moment and there is no way of determining if the user has other than these markets specified for preferred.
      this.market = 'SANTA_BARBARA_MARKET';
  }

  toLogin(){
    this.router.navigate(['/login']);
  }

  onSubmit() {
      this.msg = [];
      this.submitted = true;
      let userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.recoverPassData.value));
      if (this.recoverPassData.valid === false) {
          this.msg.push({ severity: 'error', detail: 'Please fill an email' });
      } else {
          this.hideUI = true;
          userData.username = userData.username.toLowerCase();
          let objToSend = {
              'market': this.market,
              'username': userData.username
          };

          this.userService.recoverPassword(objToSend)
              .subscribe(
              data => {
                  this.msg.push({ severity: 'success', detail: 'An email has been sent with a reset link' });
                  //this.router.navigate(['/login']);
                  this.hideUI = false;
              },
              error => {
                  if(error.parameterErrors != undefined) {
                      for (let i = 0; i < error.parameterErrors.length; i++) {
                          this.msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
                      }
                  } else if(error.message.length != 0) {
                      this.msg.push({ severity: 'error', detail: error.message });
                  }
                  this.hideUI = false;
              }
          );
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/thankyou/thankyou.component.ts